import config from '../services/config';

export const ACCOUNT_BLOCKED_MESSAGE = 'User is locked, please check email/sms for unlock instruction.';
export const INVALID_PASSWORD_MESSAGE = 'Invalid Password';
export const EMAIL_ALREADY_VERIFIED = 'Your email is already verified, please login again.';
export const PARTNER_STAFF_USER_ROLE = 'Partner';

export const PRODUCT_NAME = () => ('PayU' + config.get('product', 'PAYU').toLowerCase().substring(4));
export const SIGNUP_PAGE_TITLE = () => (PRODUCT_NAME() + ' Sign Up');
